import { jwtVerify } from 'jose';
import { ISession } from './types';
import { decompress } from './decompress';

const secretKey = process.env.SESSION_SECRET;
const encodedKey = new TextEncoder().encode(secretKey);

export async function decrypt(token: string): Promise<ISession | undefined> {
  try {
    const { payload } = await jwtVerify(token, encodedKey, { algorithms: ['HS256'] });
    return await decompress<ISession>(payload.data as string);
  } catch (error) {
    console.log('Failed to verify session', error);
  }
}
